import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ByWordPipe } from '../../../filters/by-word/by-word.pipe';
import { NgClass, NgStyle } from '@angular/common';
import { SpanTooltipComponent } from '@shared/components/span-tooltip/span-tooltip.component';

@Component({
    selector: 'tree-list-children',
    templateUrl: './tree-list-children.component.html',
    standalone: true,
    imports: [
      NgClass,
      NgStyle,
      ByWordPipe,
      SpanTooltipComponent
  ]
})
export class TreeListChildrenComponent {
  @Input() field: any = null;
  @Input() level: number = 1;
  @Input() findDropdown: any = '';
  @Input() fieldToFind: any = '';
  @Input() filterList: any = [];
  @Output() treeChildrenEmit = new EventEmitter();

  nextLevel: number = this.level + 1;

  constructor(){}

  launchAction(listValue:any){
    let selectedItem={
      listValue: listValue
    }
    this.treeChildrenEmit.emit(selectedItem);
  }

  treeChildrenOn(event:any){
    this.launchAction(event.listValue);
  }

}
